import { Geolocation } from 'src/app/core/models/geolocation.model';

export const ijsselGeolocation: Geolocation = {
  lat: 52.2733711,
  lng: 5.6986093,
  id: 0,
  label: 'IJssel',
};
